import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GamesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"games"}/>
}
